import React, { useEffect } from 'react'
import { NonprofitDetailsComponent } from './non-profit-details-component'
import { useNonprofitDetailsPage } from './non-profit-details-page.hooks'
import { Container, LinearProgress } from '@material-ui/core'

export const NonprofitDetailsPage: React.FC = () => {
  const {
    detailProps,
    getNonprofitDetails,
    loading,
    loadSelectCategory,
    nonprofitCategory,
  } = useNonprofitDetailsPage()

  //Get Item Detail
  useEffect(() => {
    getNonprofitDetails(<></>)
  }, [])

  useEffect(() => {
    loadSelectCategory(detailProps?.categoryId ? detailProps.categoryId : 0)
  }, [detailProps])

  const fullDetailsProps = {
    ...detailProps,
    categoryName: nonprofitCategory?.name,
  }

  return (
    <>
      {loading && <LinearProgress />}
      <Container>
        {/*@ts-ignore*/}
        <NonprofitDetailsComponent {...fullDetailsProps} />
      </Container>
    </>
  )
}
